import { render, staticRenderFns } from "./Watchlist.vue?vue&type=template&id=4cd3ca36&scoped=true"
import script from "./Watchlist.vue?vue&type=script&setup=true&lang=ts"
export * from "./Watchlist.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Watchlist.vue?vue&type=style&index=0&id=4cd3ca36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd3ca36",
  null
  
)

export default component.exports